import {
  scannedBizJustA,
  scannedBizJustB,
  scannedBizJustC,
  getBizJustQABase,
  bizJustQAJoiner,
  bizJustAFieldId,
  bizJustBFieldId,
  bizJustCFieldId,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-two/business-justification-constants';
import { whyNoNetworkItSecurityApprovalId } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two-constants';
import { getNotesJSONData } from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-logic';



const getQuestionIndex = (possibleQuestions, notes, questionNumber) => {

  for (let index = 0; index < possibleQuestions.length; index++) {
    const question = possibleQuestions[index];
    const bizJustQABase = getBizJustQABase(question, questionNumber);

    const questionIndex = notes.indexOf(bizJustQABase);

    // questionIndex is -1 if it cannot find the question
    if (questionIndex >= 0) {
      return {
        start: questionIndex,
        end: questionIndex + bizJustQABase.length,
      };
    }
  }

  console.error(`Cannot find question index of of possibleQuestions: ${possibleQuestions.join(', ')}\n\nin notes: \n${notes}.\n\nAs such some formFields cannot be filled in`);

  // if the question cannot be found, return the indexes as -1 so the nothing gets sliced out of the text
  return {
    start: -1,
    end: -1,
  };

};


// Unpacks the business justification work info item form field/values
const unpackBusinessJustification = (businessJustificationWii) => {

  if (!businessJustificationWii) {
    console.error(`Unable to unpack businessJustificationWii: ${businessJustificationWii}.
    Setting associated formfields to ''`);
    return ({
      [bizJustAFieldId]: '',
      [bizJustBFieldId]: '',
      [bizJustCFieldId]: '',
    });
  }

  const {
    notes,
  } = businessJustificationWii;

  if (!notes) {
    console.error(`Unable to read notes: ${notes}.
    Setting associated formfields to ''`);
    return ({
      [bizJustAFieldId]: '',
      [bizJustBFieldId]: '',
      [bizJustCFieldId]: '',
    });
  }


  const answerPadding = bizJustQAJoiner.length;

  const question1 = getQuestionIndex(scannedBizJustA, notes, 1);
  const question2 = getQuestionIndex(scannedBizJustB, notes, 2);
  const question3 = getQuestionIndex(scannedBizJustC, notes, 3);

  // we add new lines on the end of answers which needs to be trimmed
  const answer1 = notes.slice(question1.end, (question2.start - answerPadding));
  const answer2 = notes.slice(question2.end, (question3.start - answerPadding));
  const answer3 = notes.slice(question3.end);


  return ({
    [bizJustAFieldId]: answer1,
    [bizJustBFieldId]: answer2,
    [bizJustCFieldId]: answer3,
  });
};





// Unpacks the business justification work info item form field/values
const unpackNetworkItSecurityAssesmentNotRequired = (networkItSecurityAssesmentNotRequiredWii) => {

  if (!networkItSecurityAssesmentNotRequiredWii) {
    return ({
      [whyNoNetworkItSecurityApprovalId]: '',
    });
  }

  const {
    summary,
  } = networkItSecurityAssesmentNotRequiredWii;


  return ({
    [whyNoNetworkItSecurityApprovalId]: summary ? summary : '',
  });

};


const unpackApprovalHistoryWiis = (approvalHistoryWiis) => approvalHistoryWiis.map((approvalHistoryWii) => {
  const {
    notes,
    id,
  } = approvalHistoryWii;
  const approvalMetadata = getNotesJSONData(notes);
  return ({
    ...approvalMetadata,
    id,
  });
});


export {
  unpackBusinessJustification,
  unpackNetworkItSecurityAssesmentNotRequired,
  unpackApprovalHistoryWiis,
};

